<template>
  <div class="dataSummary_box">
    <!-- 左边展示 -->
    <div class="left-summary">
      <div class="summary-item">
        <div class="icon-wrapper member-bg">
          <img
            src="@/assets/images/memberAll/totalNumberOfMembers.png"
            alt="" />
        </div>
        <div class="info">
          <div class="label">会员总数</div>
          <div class="num">{{ summaryData.memberCount }}</div>
        </div>
      </div>
      <div class="summary-item">
        <div class="icon-wrapper score-bg">
          <img src="@/assets/images/memberAll/totalPoints.png" alt="" />
        </div>
        <div class="info">
          <div class="label">积分总额</div>
          <div class="num">{{ summaryData.scoreCount }}</div>
        </div>
      </div>
    </div>
    <!-- 右边数据 -->
    <div class="right-content">
      <!-- 会员等级分析 -->
      <div class="analysis-card">
        <div class="card-title"><span class="dot"></span>会员等级分析</div>
        <div class="card-body">
          <div class="chart-box" ref="gradeChart"></div>
          <div class="table-box">
            <y-table
              :showPage="false"
              :tableData="summaryData.memberGradeStats"
              :tableInfo="tableInfo1"
              :loading="talbeLoading">
            </y-table>
          </div>
        </div>
      </div>
      <!-- 会员积分分析 -->
      <div class="score-analysis-card">
        <div class="left-chart-section">
          <div class="card-title"><span class="dot"></span>会员积分分析</div>
          <div class="chart-box" ref="scoreChart"></div>
        </div>
        <div class="right-table-section">
          <div class="table-box">
            <y-table
              :showPage="false"
              :tableData="summaryData.scoreIntervalStats"
              :tableInfo="tableInfo2"
              :loading="talbeLoading">
            </y-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMemberOverviewData } from "@/api/memberMessageSystem";
export default {
  props: {
    memberId: {
      type: String,
    },
    shopData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      summaryData: {
        scoreCount: null,
        scoreIntervalStats: [],
        memberCount: null,
        memberGradeStats: [],
      },
      gradeChartInstance: null,
      scoreChartInstance: null,
      tableData1: [],
      tableInfo1: [
        {
          label: "级别名称",
          prop: "gradeName",
        },
        {
          label: "会员数",
          prop: "count",
        },
        {
          label: "积分",
          prop: "gradeSumTotalScores",
        },
        {
          label: "占比",
          prop: "percentage",
        },
      ],
      tableInfo2: [
        {
          label: "积分区间",
          prop: "scoreInterval",
        },
        {
          label: "会员数",
          prop: "memberCount",
        },
        {
          label: "占比",
          prop: "percentage",
        },
      ],
      talbeLoading: false,
    };
  },
  mounted() {
    this.getSummaryData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeCharts);
  },
  methods: {
    async getSummaryData() {
      try {
        this.talbeLoading = true;
        const res = await getMemberOverviewData({
          cardId: this.$store.state.MemberSystemInfo.scoresCardId,
        });
        if (res.code == 200) {
          this.summaryData = res.data;
          this.$nextTick(() => {
            this.initCharts();
            window.addEventListener("resize", this.resizeCharts);
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.talbeLoading = false;
      }
    },
    resizeCharts() {
      if (this.gradeChartInstance) this.gradeChartInstance.resize();
      if (this.scoreChartInstance) this.scoreChartInstance.resize();
    },
    initCharts() {
      this.drawGradeChart();
      this.drawScoreChart();
    },
    drawGradeChart() {
      const dom = this.$refs.gradeChart;
      if (!dom) return;
      this.gradeChartInstance = this.$echarts.init(dom);
      const data = this.summaryData.memberGradeStats.map((item) => ({
        name: item.gradeName,
        value: item.count,
      }));

      const option = {
        color: [
          "#5DDDF3",
          "#61BFFF",
          "#397BFF",
          "#FF975C",
          "#FFC020",
          "#2ED9C8",
        ],
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666",
          },
          padding: [10, 15],
          extraCssText: "box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);",
          formatter: (params) => {
            return `${params.marker} ${params.value}人 &nbsp;&nbsp; ${params.percent}%`;
          },
        },
        series: [
          {
            name: "会员等级",
            type: "pie",
            radius: ["35%", "50%"],
            hoverAnimation: false,
            avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: function (params) {
                if (params.name && params.name.length > 8) {
                  return params.name.substring(0, 8) + "...";
                }
                return params.name;
              },
              color: "#666666",
              fontFamily: "PingFang SC, PingFang SC",
              fontWeight: 400,
              fontSize: 12,
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10,
              lineStyle: {
                color: "#999",
              },
            },
            data: data,
          },
        ],
      };
      this.gradeChartInstance.setOption(option);
    },
    drawScoreChart() {
      const dom = this.$refs.scoreChart;
      if (!dom) return;
      this.scoreChartInstance = this.$echarts.init(dom);
      const data = this.summaryData.scoreIntervalStats.map((item) => ({
        name: item.scoreInterval,
        value: item.memberCount,
      }));

      const option = {
        color: [
          "#2ED8C7",
          "#5CDCF2",
          "#61BFFF",
          "#397BFF",
          "#FF6B6B",
          "#FF975C",
          "#F4B820", //现有颜色
          "#C70039",
          "#900C3F",
          "#581845",
          "#DAF7A6",
          "#33FF57",
        ],
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          textStyle: {
            color: "#666",
          },
          padding: [10, 15],
          extraCssText: "box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);",
          formatter: (params) => {
            return `${params.marker} ${params.value}人 &nbsp;&nbsp; ${params.percent}%`;
          },
        },
        series: [
          {
            name: "积分区间",
            type: "pie",
            radius: ["35%", "50%"],
            hoverAnimation: false,
            avoidLabelOverlap: true,
            label: {
              show: true,
              formatter: function (params) {
                if (params.name && params.name.length > 8) {
                  return params.name.substring(0, 8) + "...";
                }
                return params.name;
              },
              color: "#666666",
              fontFamily: "PingFang SC, PingFang SC",
              fontWeight: 400,
              fontSize: 12,
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 10,
              lineStyle: {
                color: "#999",
              },
            },
            data: data,
          },
        ],
      };
      this.scoreChartInstance.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.dataSummary_box {
  display: flex;
  padding: 10px;
  box-sizing: border-box;

  .left-summary {
    width: 160px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;

    .summary-item {
      display: flex;
      align-items: center;
      .icon-wrapper {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        img {
          width: 40px;
          height: 40px;
        }
      }

      .info {
        .label {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          margin-bottom: 4px;
        }
        .num {
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }

  .right-content {
    flex: 1;
    display: flex;
    gap: 24px;

    .analysis-card {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      height: 364px;
      box-shadow: 0px 4px 4px 0px rgba(207, 221, 255, 0.25);
      border: 1px solid #f5f5ff;

      .card-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 12px;
        color: #333333;
        display: flex;
        align-items: center;

        .dot {
          width: 6px;
          height: 6px;
          background: #007bff;
          border-radius: 50%;
          margin-right: 4px;
        }
      }

      .card-body {
        flex: 1;
        display: flex;
        align-items: center;

        .chart-box {
          flex: 1;
          height: 100%;
          min-height: 250px;
        }

        .table-box {
          flex: 1;
          height: 280px;
          margin-left: 10px;
        }
      }
    }

    .score-analysis-card {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 16px;
      display: flex;
      box-shadow: 0px 4px 4px 0px rgba(207, 221, 255, 0.25);
      border: 1px solid #f5f5ff;
      height: 364px;

      .left-chart-section {
        width: 50%;
        display: flex;
        flex-direction: column;

        .card-title {
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 12px;
          color: #333333;
          display: flex;
          align-items: center;
          height: 20px;
          margin-bottom: 10px;

          .dot {
            width: 6px;
            height: 6px;
            background: #007bff;
            border-radius: 50%;
            margin-right: 4px;
          }
        }

        .chart-box {
          flex: 1;
          width: 100%;
        }
      }

      .right-table-section {
        width: 50%;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;

        .table-box {
          width: 100%;
          height: 320px;
        }
      }
    }
  }
}
</style>
